
export const WATER_QUALITY_NOTIFICATION = [
  {
    label: 'ph',
    unit: '',
  },
  {
    label: 'alkali',
    unit: 'ppm',
  },
  {
    label: 'temperature',
    unit: '°C',
  },
  {
    label: 'nitrite',
    unit: 'ppm',
  },
  {
    label: 'do',
    unit: 'ppm',
  },
  {
    label: 'ammonia',
    unit: 'ppm',
  },
  {
    label: 'turbidity',
    unit: 'NTU',
  },
  {
    label: 'salinity',
    unit: 'ppt',
  },
]


// NK-272: "ตั้งค่าทั่วไป" keeps one min/max; "ตั้งค่าระดับสูง" sets min/max per
// shrimp-age range. Order matches the design.
export const GENERAL_WATER_QUALITY_PARAMETERS = ['temperature', 'do']
export const AGE_RANGE_WATER_QUALITY_PARAMETERS = ['ph', 'alkali', 'nitrite', 'ammonia', 'turbidity']

// Matches the backend bound (service/water_quality_threshold_age_range.go).
export const MAX_THRESHOLD_SHRIMP_AGE = 9999

// NK-273: shrimp-health alert settings — the three samples and four vibrio
// colours, in design order. The backend keys them by these strings.
export const SHRIMP_HEALTH_TARGETS = ['liver', 'stomach', 'water'] as const
export const SHRIMP_HEALTH_COLORS = ['yellow', 'green', 'black', 'green_yellow'] as const

// Green alerts only after the count stays over the limit this many days in a
// row; matches the backend bound (service/shrimp_health_threshold.go).
export const MAX_SHRIMP_HEALTH_CONSECUTIVE_DAYS = 30
